function overflow(els, innerClassName = "overflow-container__inner") {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        // wrap inner element in a div
        let wrapper = document.createElement("div");
        wrapper.setAttribute("class", innerClassName);

        el.appendChild(wrapper);

        while (el.firstChild !== wrapper) wrapper.appendChild(el.firstChild);

        let container = el.getElementsByClassName(innerClassName)[0];

        // get initial overflow position (left/right/both/none)
        getOverflow(container);

        let containerScrollLeft = 0;

        container.addEventListener(
            "scroll",
            function(e) {
                containerScrollLeft = e.scrollLeft;

                window.requestAnimationFrame(function() {
                    getOverflow(container, containerScrollLeft);
                });
            },
            {
                passive: true,
                once: false,
            }
        );

        window.addEventListener(
            "resize",
            function() {
                containerScrollLeft = container.scrollLeft;

                window.requestAnimationFrame(function() {
                    getOverflow(container, containerScrollLeft);
                });
            },
            {
                passive: true,
                once: false,
            }
        );
    }
}

function getOverflow(el, cur = el.scrollLeft) {
    var container = el.parentNode;
    // var cur = el.scrollLeft;

    var children = el.children[0];

    // if container is not scrollable (children width is less than the container width)...
    if (container.offsetWidth >= children.offsetWidth) {
        // set data-overflow attr on container to none.
        container.setAttribute("data-overflow", "none");

        // else if container IS scrollable (children width is greater than the container width)...
    } else {
        // If element has NOT been scrolled...
        if (cur == 0) {
            // set data-overflow attr on container to right.
            container.setAttribute("data-overflow", "right");

            // Else if element HAS been scrolled...
        } else {
            var max = el.scrollWidth - el.parentNode.offsetWidth;

            // If element has been scrolled to the end...
            if (cur == max) {
                // set data-overflow attr on container to left.
                container.setAttribute("data-overflow", "left");

                // else if element has NOT been scrolled to the end...
            } else {
                // set data-overflow attr on container to both.
                container.setAttribute("data-overflow", "both");
            }
        }
    }
}

export default overflow;
